import { Button, Container, Eyebrow, Section } from '@vcn/ui'
import { useContent } from "../content";

export function Audiences() {
  const { audiences } = useContent();

  return (
    <Section id="zielgruppen" className="scroll-mt-20 pt-8 sm:pt-10">
      <Container>
        <div className="grid items-stretch gap-14 md:grid-cols-2 md:gap-12">
          {audiences.map((item, index) => (
            <article
              key={item.id}
              id={item.id}
              className={[
                'flex flex-col items-center text-center',
                index === 0 ? 'md:items-end md:text-right' : 'md:items-start md:text-left',
              ].join(' ')}
            >
              <Eyebrow as="h2">{item.role}</Eyebrow>

              <p className="mt-4 text-2xl leading-tight font-bold text-balance text-white sm:text-[1.7rem]">
                {item.title.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>

              <p className="mt-5 max-w-md text-[0.95rem] leading-relaxed text-pretty text-white/85">
                {item.body}
              </p>

              {/* `mt-auto` hält beide Buttons auf gleicher Höhe, auch wenn die
                  Texte unterschiedlich lang sind. */}
              <div className="mt-auto pt-8">
                <Button href={item.cta.href} variant={item.cta.variant}>
                  {item.cta.label}
                </Button>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </Section>
  )
}
